import data from "@/data/google-reviews.json";

export type GoogleReview = {
  reviewId: string;
  reviewer: {
    displayName: string;
    profilePhotoUrl?: string;
    isAnonymous?: boolean;
  };
  starRating: number;
  comment: string;
  createTime: string; // ISO
  relativeTime?: string; // e.g. "2 weeks ago"
  city?: string;
};

export type ReviewsData = {
  source: string;
  placeName: string;
  rating: number;
  totalReviews: number;
  fetchedAt: string | null;
  reviews: GoogleReview[];
};

export const reviewsData = data as ReviewsData;

/** Reviews suitable for display: 4★+ with a non-empty comment, newest first. */
export const displayReviews: GoogleReview[] = [...reviewsData.reviews]
  .filter((r) => r.starRating >= 4 && r.comment && r.comment.trim().length > 0)
  .sort((a, b) => (a.createTime < b.createTime ? 1 : -1));
